'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateChange = calculateChange;
function calculateChange(e, skip, props, container) {
  !skip && e.preventDefault();
  var containerWidth = container.clientWidth;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
  var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));

  var a = void 0;
  if (left < 0) {
    a = 0;
  } else if (left > containerWidth) {
    a = 1;
  } else {
    a = Math.round(left * 100 / containerWidth) / 100;
  }

  if (props.a !== a) {
    return {
      h: props.hsl.h,
      s: props.hsl.s,
      l: props.hsl.l,
      a: a,
      source: 'rgb'
    };
  }
  return null;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-color/lib/helpers/alpha.js
// module id = 1231
// module chunks = 0